import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { HistoriqueExports } from './HistoriqueExports';
import { RecusDuMois } from './RecusDuMois';
import { ComptesExpertComptable } from './ComptesExpertComptable';

export const ComptabiliteAdminPanel = () => {
  const { getAuthHeader, user } = useAuth();
  const superAdmin = user?.role === 'super_admin';
  return (
    <div className="space-y-4" data-testid="comptabilite-admin-panel">
      <HistoriqueExports headers={getAuthHeader()} canResend={superAdmin} />
      <RecusDuMois headers={getAuthHeader()} />
      {superAdmin && <ComptesExpertComptable headers={getAuthHeader()} />}
    </div>
  );
};
